import * as React from "react";
import JwtDecode from "jwt-decode";

export interface AuthState {
    token?: string;
    refreshedAt?: number;
    subject?: string;
    expires?: number;
    permissions?: string[];
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
}

interface JwtToken {
    sub: string;
    exp: number;
    perm: string[];
}

export interface GlobalState {
    loading: boolean;
    initialLoad: boolean;
    wsConnected: boolean;
    auth: AuthState;
    updateAuth: (token?: string) => void;
    setWsConnected: (wsConnected: boolean) => void;
}

export const GlobalContext = React.createContext<GlobalState>({} as any);

export default class GlobalProvider extends React.Component<React.PropsWithChildren<{}>, GlobalState> {
    setWsConnected = (wsConnected: boolean) => this.setState({ ...this.state, wsConnected });

    updateAuth = async (token?: string) => {
        let state: GlobalState = { ...this.state, initialLoad: true };
        if (!token) {
            state.auth = {};
        } else {
            let jwt = JwtDecode<JwtToken>(token);

            state.auth = {
                token,
                refreshedAt: Date.now() / 1000,
                subject: jwt.sub,
                expires: jwt.exp,
                permissions: jwt.perm,
            };

        }

        this.setState(state);
    };

    state: GlobalState = {
        loading: false,
        initialLoad: false,
        auth: {},
        wsConnected: false,
        updateAuth: this.updateAuth,
        setWsConnected: this.setWsConnected,
    };

    render() {
        return <GlobalContext.Provider value={this.state}>
            {this.props.children}
        </GlobalContext.Provider>;
    }
}

// Returns new token, false on unauthorized, throws exception on error
export async function getAccessToken() {
    // Returns new token, false on unauthorized, throws exception on error
    try {
        // For this we need to fetch from the app server (i.e. app.vonix.io instead of integration.vonix.io
        let endpoint = window.location.protocol + '//' + window.location.hostname.replace(/^([a-z]*)\./g, 'app.') +
            '/api/v1/auth/token';

        let response = await fetch(endpoint, {
            credentials: 'include',
            method: 'GET',
            cache: 'no-cache',
            mode: 'cors',
            headers: {'Content-Type': 'application/json'}
        });

        if (response.ok) {
            let json = await response.json();
            return json.accessToken;
        } else {
            if (response.status === 401) {
                return false;
            }
        }
    } catch (e) {
        throw e;
    }

    // Unknown exception occurred
    throw new Error('Unknown error while getting token.');
}